import { Link, Head } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export default function Home() {
  return (
    <>
      <Head title="Tubery">
        <meta
          name="description"
          content="Tubery — the Builder Methods clips library. A Dropbox-synced B-roll archive with agent-assisted organization."
        />
        <meta property="og:title" content="Tubery" />
        <meta
          property="og:description"
          content="Tubery — the Builder Methods clips library. A Dropbox-synced B-roll archive with agent-assisted organization."
        />
      </Head>
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-4 py-16 text-center">
        <h1>Tubery.</h1>
        <p className="mt-2 max-w-md text-ink-muted">
          The Builder Methods clips library — a Dropbox-synced B-roll archive
          with agent-assisted organization.
        </p>
        <div className="mt-6 flex items-center gap-3">
          <Button asChild>
            <Link href="/login">Log in</Link>
          </Button>
        </div>
      </main>
    </>
  )
}
